export const selectAppointmentData = (state:any) => state.appointment.appoinmentData;

export const selectTotalPrice = (state:any) => state.appointment.totalPrice

export const selectTotalTime = (state:any) => state.appointment.totalTime

export const selectSelectedClient = (state:any) => state.appointment.selectedClient
export const selectSelectedAppointmentEditData = (state:any) => state.appointment.selectedAppointmentEditData
export const selectCalenderAppointmentDate = (state:any) => state.appointment.selectedCalenderAppointmentDate

export const selectShowAppointmnetSuccess = (state:any) => state.appointment.showAppointmentSuccess

export const selectShowCustomerAppointmnetModal = (state:any) => state.appointment.showCustomerAppointmentModal


export const selectSuccessedAppointmentData = (state:any) => state.appointment.successedAppointmentData;
export const selectDuplicateSuccessAppointmentData = (state:any) => state.appointment.duplicateSuccessAppointmentData;

export const selectSuccessedAppointmentLoading = (state:any) => state.appointment.successAppointmentLoading;

export const selectUpdateAppointmentId = (state:any) => state.appointment.updateAppointmentId;

export const selectData = (state:any) => state.appointment.data;
export const selectAppointmentApiData = (state:any) => state.appointment.appointmentApiData;
export const selectCreateAppData = (state:any) => state.appointment.createAppData;

export const selectAppointmentFilterData = (state:any) => state.appointment.appointmentFilterData;
export const selectAppointmentDeleteModal = (state:any) => state.appointment.showAppointmentDeleteModal;
export const selectEditAppointmentForm = (state:any) => state.appointment.editAppointmentForm;

export const selectTotalAppointmentCount = (state:any) => state.appointment.totalAppointmentCount;
export const selectAppointmentInvoice = (state:any) => state.appointment.appointmentInvoice;

export const selectAppointmentHistory = (state:any) => state.appointment.appointmentHistory;

export const selectDoubleAppointmentPopup= (state:any) => state.appointment.doubleAppointmentPopup;

export const selectEmployeeLeaveStatus= (state:any) => state.appointment.employeeLeaveStatus;

export const selectAppointmentRowCounts= (state:any) => state.appointment.appointmnetRowCounts;

export const selectOpenTransaction = (state:any) => state.appointment.openTransactionModal;

export const selectPaymentTransationData = (state:any) => state.appointment.paymentTransactionData;
export const selectOpenQrModal = (state:any) => state.appointment.openQrModal;